import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { InstallSlackWorkspaceResponse } from '@cast/types';

import { getSlackRedirectUri } from './_utils/getSlackRedirectUri';

import { FormMode } from '@cast/shared-rff-ui';

type InstallSlackWorkspaceParams = {
  formState?: Record<string, any>;
  mode?: FormMode;
  currentPath?: string;
  alertId?: string;
};

export const useInstallSlackWorkspace = (): UseMutationResult<
  AxiosResponse<InstallSlackWorkspaceResponse>,
  unknown,
  InstallSlackWorkspaceParams | void,
  unknown
> => {
  return useMutation({
    mutationFn: () => {
      return apiClient.notifications.slackWorkspacesInstall({});
    },
    onSuccess: (response, variables) => {
      const installUrl = response.data.installUrl;

      if (installUrl) {
        const url = new URL(installUrl);
        const installState = url.searchParams.get('state');
        // Add all state as a single 'state' query parameter
        if (variables?.formState) {
          const state = {
            formState: variables.formState,
            mode: variables.mode,
            alertId: variables.alertId,
            installState,
          };

          url.searchParams.set('state', JSON.stringify(state));
        }

        url.searchParams.set('redirect_uri', getSlackRedirectUri());

        window.open(url.toString(), '_self');
      }
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
